import { AnalyticsBrowser } from '@segment/analytics-next';
import { createContext, useMemo } from 'react';

import { createUseContext } from '../../utils';
import { IAnalyticsProviderProps } from './types';

const AnalyticsContext = createContext<AnalyticsBrowser | null>(null);
AnalyticsContext.displayName = 'Analytics Context';

export const AnalyticsProvider = ({ children, writeKey }: IAnalyticsProviderProps) => {
  const analytics = useMemo(() => AnalyticsBrowser.load({ writeKey }), [writeKey]);

  return <AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>;
};

export const useAnalytics = createUseContext(AnalyticsContext);
